import { render, staticRenderFns } from "./time-budget.vue?vue&type=template&id=58c76dd4&"
import script from "./time-budget.vue?vue&type=script&lang=js&"
export * from "./time-budget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports